/**
 * The shape of a reactive-call page-file row as the rest of the portal expects a call (PORTAL-199).
 *
 * A pure module with only the one import below, so a test can use the very same function the browser does
 * rather than a copy.
 *
 * WHAT THE PAGE ROW IS AND IS NOT. It is one row of Live.vReactiveCall: the columns Home and the SLA
 * indicator need, in the same names the live API uses for them. It is NOT the live API's whole call - there is
 * no FaultNotes, RepairNotes, Action, engineer or address detail - so a list built from it is a Home list, and
 * the Reactive page, which opens a call's detail, reads the live list itself when it is opened.
 *
 * TWO NAMES DIFFER FROM THE LIVE API and are mapped here, once, so nothing downstream has to know:
 *   HoldReasonCode  -> HoldReason   the live call carries the code AND its wording; the page carries the code.
 *                                   Anything that tests "is there a hold reason" only needs it to be non-empty.
 *   (none)          -> CallLocations the page has no call-location text; the live list carries '' for it on every
 *                                   customer tested, and the card tests it for emptiness.
 *
 * STATUS COMES FROM SQL, NOT FROM THE BROWSER'S RULE. calculateStatus works the seven-way status out from the
 * live fields, one of which (the hold reason's wording, "Hold Reason not defined") the page does not carry. The
 * database already holds the same rule (PortalStatus, PORTAL-199) and it was proved equal to the browser's, so
 * the page's value is used and the browser's own result is kept only where the page gave none.
 */

import { normaliseRow } from './pmCallPagesShape';

export const PORTAL_STATUSES = ['new', 'allocated', 'inProgress', 'onHold', 'cancelled', 'workCompleted', 'finished'];

/** One page row, as the old path would have delivered a live call, before calculateStatus runs. */
export function reactiveRowToJob(row: Record<string, any>): Record<string, any> {
  const job = normaliseRow(row);

  job.HoldReason = job.HoldReasonCode ?? '';
  job.CallLocations = '';

  return job;
}

/** After calculateStatus: the database's status wins where it gave a recognised one. */
export function applyPortalStatus(job: Record<string, any>): Record<string, any> {
  const portalStatus = job.PortalStatus;

  if (typeof portalStatus === 'string' && PORTAL_STATUSES.includes(portalStatus)) {
    job.Status = portalStatus;
  }

  return job;
}
